/**
 * Rounds a number to the specified number of decimal places
 * @param value - The number to round
 * @param decimals - Number of decimal places (default: 0)
 * @returns The rounded number
 */
export function roundToPrecision(value: number, decimals: number = 0): number {
  const multiplier = Math.pow(10, decimals);
  return Math.round(value * multiplier) / multiplier;
}

/**
 * Rounds geographic coordinates to 5 decimal places (~1 meter precision)
 */
export function roundCoordinate(coordinate: number): number {
  return roundToPrecision(coordinate, 5);
}

/**
 * Rounds zoom level to 1 decimal place
 */
export function roundZoomLevel(zoom: number): number {
  return roundToPrecision(zoom, 1);
}
